import agmaMark from '../../assets/agma-mark.png';

type Props = {
  approvalType: string;
  variant?: 'compact' | 'full';
};

export default function ApprovalTypeBadge({ approvalType, variant = 'compact' }: Props) {
  if (approvalType === 'agma') {
    return (
      <span className='approval-type-badge approval-type-badge--agma'>
        <img src={agmaMark} alt={variant === 'full' ? 'AGMA Approval' : 'AGMA'} className='approval-type-badge__mark' />
      </span>
    );
  }
  if (approvalType === 'single_point') {
    return (
      <span className='approval-type-badge approval-type-badge--single-point'>
        {variant === 'full' ? 'Single Point Approval' : 'Single Point'}
      </span>
    );
  }
  return null;
}
